import * as _module2 from "module";

var _module = "default" in _module2 ? _module2.default : _module2;

import _process from "process";
var exports = {};
var process = _process;
const {
  builtinModules
} = _module;
const ignoreList = ["sys"]; // eslint-disable-next-line node/no-deprecated-api

exports = (builtinModules || (process.binding ? Object.keys(process.binding("natives")) : []) || []).filter(x => !/^_|^(internal|v8|node-inspect)\/|\//.test(x) && !ignoreList.includes(x)).sort();
export default exports;